import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const BiometricsPage = lazy(() => import("./BiometricsPage"));

const BiometricsPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <BiometricsPage />
    </Suspense>
  );
};

export default BiometricsPageLazy;
